import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import ArticlePage from "@/pages/ArticlePage";
import CategoryPage from "@/pages/CategoryPage";
import SearchPage from "@/pages/SearchPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ShortViewer from "@/pages/ShortViewer";
import ShortsIndex from "@/pages/ShortsIndex";
import PopuIaPage from "@/pages/PopuIaPage";
import CmsPage from "@/pages/CmsPage";
import ContactPage from "@/pages/ContactPage";
import AuthorPage from "@/pages/AuthorPage";
import FlightsPage from "@/pages/FlightsPage";
import TransitabilityPage from "@/pages/TransitabilityPage";
import OpinionPage from "@/pages/OpinionPage";
import OpinionArticlePage from "@/pages/OpinionArticlePage";
import PollVotePage from "@/pages/PollVotePage";
import PollResultsPage from "@/pages/PollResultsPage";
import PollResultsTVPage from "@/pages/PollResultsTVPage";
import ShortsFeedPage from "@/pages/ShortsFeedPage";
import { trackPageview } from "@/lib/analytics";
import InstallPrompt from "@/components/InstallPrompt";
import NotificationPrompt from "@/components/NotificationPrompt";
import MobileBottomNav from "@/components/MobileBottomNav";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Toaster } from "sonner";

function MobileNavGate() {
  const loc = useLocation();
  const hide =
    loc.pathname.startsWith("/admin") ||
    /^\/shorts\/[^/]+/.test(loc.pathname) ||
    /^\/encuesta\/[^/]+\/tv$/.test(loc.pathname) ||
    loc.pathname === "/shorts-feed"; // vertical infinite feed
  if (hide) return null;
  return <MobileBottomNav />;
}

function AnalyticsListener() {
  const loc = useLocation();
  useEffect(() => {
    // Skip tracking admin + special output pages
    if (loc.pathname.startsWith("/admin")) return;
    if (/^\/encuesta\/[^/]+\/tv$/.test(loc.pathname)) return;
    // Article pageviews are tracked separately in ArticlePage with slug/id/duration
    if (/^\/nota\//.test(loc.pathname)) return;
    if (/^\/opinion\//.test(loc.pathname)) return;
    trackPageview({ path: loc.pathname });
  }, [loc.pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/categoria/:slug" element={<CategoryPage />} />
            <Route path="/nota/:slug" element={<ArticlePage />} />
            <Route path="/shorts" element={<ShortsIndex />} />
            <Route path="/shorts/:slug" element={<ShortViewer />} />
            <Route path="/popu-ia" element={<PopuIaPage />} />
            <Route path="/buscar" element={<SearchPage />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/autor/:slug" element={<AuthorPage />} />
            <Route path="/vuelos" element={<FlightsPage />} />
            <Route path="/transitabilidad" element={<TransitabilityPage />} />
            <Route path="/opinion" element={<OpinionPage />} />
            <Route path="/opinion/:slug" element={<OpinionArticlePage />} />
            <Route path="/encuesta/:slug" element={<PollVotePage />} />
            <Route path="/encuesta/:slug/resultados" element={<PollResultsPage />} />
            <Route path="/encuesta/:slug/tv" element={<PollResultsTVPage />} />
            <Route path="/shorts-feed" element={<ShortsFeedPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/:slug" element={<CmsPage />} />
          </Routes>
          <MobileNavGate />
          <AnalyticsListener />
        </BrowserRouter>
        <Toaster position="bottom-right" />
        <InstallPrompt />
        <NotificationPrompt />
      </div>
    </ThemeProvider>
  );
}

export default App;
